import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../api/api.service';


export interface DocumentFilterType {
  TYPE_ID: number;
  CATEGORY_ID: number;
  TYPE_NAME: string;
  CATEGORY_NAME: string;
};

export interface DocumentFilterTypeGrouped { 
  category_name: string, 
  types: string[] 
}

@Injectable({
  providedIn: 'root'
})
export class DocumentTypesService {

  private readonly baseUrl = 'document-types'; // Base route for the documents API

  constructor(private apiService: ApiService) {}

  async get(): Promise<DocumentFilterType[]> {
    return this.apiService.call<DocumentFilterType[]>(HttpMethod.GET, `${this.baseUrl}`);
  }

  async getGrouped(): Promise<DocumentFilterTypeGrouped[]> {
    return this.apiService.call<DocumentFilterTypeGrouped[]>(HttpMethod.GET, `${this.baseUrl}/grouped`);
  }

}
